import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "AddParametreModal",
  tabindex: "-1",
  ref: "addParametreModalRef",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString($setup.title), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Form, {
              ref: "parametreForm",
              onSubmit: $setup.addParametre,
              "validation-schema": $setup.parametreSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " CLE ", -1)),
                      _createVNode(_component_Field, {
                        name: "cle",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer une clé"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "cle",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " VALEUR ", -1)),
                      _createVNode(_component_Field, {
                        name: "valeur",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer la valeur de la clé"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "valeur",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Désignation ", -1)),
                      _createVNode(_component_Field, {
                        name: "designation",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer la valeur de la clé"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "designation",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Fichier ", -1)),
                      _createVNode(_component_Field, {
                        name: "fichier",
                        type: "file",
                        accept: "image/jpeg, image/png application/pdf",
                        onChange: $setup.onFileChange,
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Choisissez un fichier"
                      }, null, 8, ["onChange"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "fichier",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("button", _hoisted_16, _toDisplayString($setup.btntext), 1)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.resetValue()))
          })
        ])
      ])
    ], 512),
    _cache[5] || (_cache[5] = _createElementVNode("div", null, null, -1))
  ], 64))
}